import React, { useState, useEffect } from 'react';

const DecryptText = ({ text, delay = 0, speed = 30 }) => {
  const [displayText, setDisplayText] = useState('');
  const [opacity, setOpacity] = useState(0);
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@#$%&*!?';

  useEffect(() => {
    let iteration = 0;
    const timeout = setTimeout(() => {
      // Start appearing
      setOpacity(0.5);
      
      const interval = setInterval(() => {
        const progress = iteration / text.length;
        setOpacity(0.5 + (progress * 0.5));
        
        setDisplayText(
          text
            .split('')
            .map((char, index) => {
              if (char === ' ' || char === '\n') return char;
              if (index < iteration) {
                return text[index];
              }
              return characters[Math.floor(Math.random() * characters.length)];
            })
            .join('')
        );

        if (iteration >= text.length) {
          clearInterval(interval);
          setOpacity(1);
        }

        iteration += 1 / 3;
      }, speed);

      return () => clearInterval(interval);
    }, delay);

    return () => clearTimeout(timeout);
  }, [text, delay, speed]);

  return (
    <span 
      className="decrypt-text"
      style={{ 
        opacity,
        transition: 'opacity 0.15s ease-out',
        display: 'inline-block'
      }}
    >
      {displayText}
    </span>
  );
};

export default DecryptText;
